import { Link } from "react-router-dom";
import { getFilmsByType } from "@/lib/filmData";

const shortcuts = [
  {
    type: "movies" as const,
    title: "电影频道",
    description: "院线佳作与经典影片，一次看遍精彩剧情。",
    icon: "ri-movie-2-line",
    tone: "bg-primary-500 text-background-50",
    badge: "bg-primary-700",
  },
  {
    type: "tv" as const,
    title: "电视剧频道",
    description: "热播剧集与口碑长篇，追剧不再迷路。",
    icon: "ri-tv-2-line",
    tone: "bg-accent-500 text-primary-950",
    badge: "bg-accent-700",
  },
];

export default function CategoryShortcuts() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:gap-5">
      {shortcuts.map((item) => {
        const count = getFilmsByType(item.type).length;
        return (
          <Link
            key={item.type}
            to={`/category/${item.type}`}
            className={`group flex items-center justify-between gap-4 overflow-hidden rounded-lg p-5 transition-transform duration-300 hover:-translate-y-1 md:p-6 ${item.tone}`}
          >
            <div>
              <div className="flex items-center gap-2">
                <h3 className="font-heading text-lg font-extrabold md:text-xl">{item.title}</h3>
                <span className="rounded-md bg-background-50/25 px-2 py-0.5 text-[11px] font-medium">
                  {count} 部作品
                </span>
              </div>
              <p className="mt-2 max-w-xs text-sm opacity-85">{item.description}</p>
              <span className="mt-4 flex items-center gap-1 text-sm font-medium">
                进入频道
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </span>
            </div>
            <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-lg bg-background-50/20 text-4xl">
              <i className={item.icon} aria-hidden="true"></i>
            </span>
          </Link>
        );
      })}
    </div>
  );
}